import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable camelcase */
import React from "react";
import styles from "./style.module.css";
/*
 * Mixes well Item Component
 */
const MixesWellItem = ({ product_image, isWide, product_title }) => (_jsxs("div", { className: `${styles.mixes_well_item} ${isWide ? styles.mixes_well_item_wide : ""}`, children: [_jsx("span", { className: styles.mixes_well_item__title, children: product_title }), _jsx("img", { className: styles.mixes_well_item__image, src: product_image, alt: "" })] }));
export default MixesWellItem;
